<template>
  <div class="empower">
    <div class="em-main">
      <nav>
        <ul>
          <li
            :class="{'em-choose':tab3_nav_choose===1}"
            @click.stop="tab3_nav_choose=1"
          >用 户</li>
          <li
            :class="{'em-choose':tab3_nav_choose===2}"
            @click.stop="tab3_nav_choose=2"
          >用 户 组</li>
          <li
            :class="{'em-choose':tab3_nav_choose===3}"
            @click.stop="tab3_nav_choose=3"
          >机构&用户组</li>
        </ul>
      </nav>
      <div class="em-trans-panel">
        <user-list v-if="tab3_nav_choose===1" />
        <user-group-list v-if="tab3_nav_choose===2" />
        <org-role v-if="tab3_nav_choose===3" />
      </div>
    </div>
  </div>
</template>
<script>
import userList from './user-list'
import userGroupList from './user-group-list'
import orgRole from './org-role'
export default {
  components: {
    userList,
    userGroupList,
    orgRole
  },
  data () {
    return {
      data: {},
      tab3_nav_choose: 1
    }
  },
  created () {
  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
@mixin ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@mixin flex-column {
  display: flex;
  flex-direction: column;
}
* {
  font-family: PingFangSC-Medium, PingFangSC;
  padding: 0;
  margin: 0;
}
.empower {
  @include flex-column;
  .em-main {
    @include flex-column;
    nav {
      border-bottom: 1px solid rgba(225, 228, 230, 1);
      ul {
        display: flex;
        li {
          margin: 0 30px;
          padding: 13px 4px;
          font-size: 14px;
          white-space: nowrap;
          list-style: none;
          transition: background 0.2s;
          color: rgba(98, 111, 121, 1);
          cursor: pointer;
          &:hover {
            border-bottom: 2px solid rgba(51, 148, 225, 1);
          }
        }
        li:first-child {
          margin-left: 20px !important;
        }
        .em-choose {
          color: rgba(51, 148, 225, 1);
          border-bottom: 2px solid rgba(51, 148, 225, 1);
        }
      }
    }
    .em-trans-panel {
      flex: 1;
      padding: 10px 10px;
    }
  }
}
</style>
